module.exports = __webpack_public_path__ + "images/psp/Locker/4x5.svg";